import { Component, OnInit } from '@angular/core';
import { AppState, selectAuthState, selectPatientState } from '../../../store/app.states';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Pending } from '../../../model/questionnaires/Pending';
import { Router } from '@angular/router';
import { GetPendings } from '../../../store/actions/patient.actions';
import * as _moment from 'moment';
// @ts-ignore
import { default as _rollupMoment } from 'moment';
const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-questionnaires',
  templateUrl: './questionnaires.component.html',
  styleUrls: ['./questionnaires.component.css']
})
export class QuestionnairesComponent implements OnInit {

  title = 'Questionari';
  user = null;
  pendings: Pending[];
  back = true;
  destination = '/landing';
  getAuthState: Observable<any>;
  getPatientState: Observable<any>;

  constructor(private store: Store<AppState>,
    private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getPatientState = this.store.select(selectPatientState);

    document.addEventListener('notification', () => {
      this.store.dispatch(new GetPendings());
      setTimeout(() => {
        this.getPatientState.subscribe((state) => this.pendings = state.pendings);
        console.log(this.pendings);
        if (this.pendings !== undefined && this.pendings !== null) {
          if (this.pendings.length !== 0) {
            this.pendings = this.pendings.slice().sort((p1, p2) => this.comparing(p1, p2));
          }
        }
      }, 500);
    });
  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      if (state.isAuthenticated) {
        this.user = JSON.parse(localStorage.getItem('user'));
      }
    });
    this.getPatientState.subscribe((state) => this.pendings = state.pendings);
    if (this.pendings !== undefined && this.pendings !== null) {
      if (this.pendings.length !== 0) {
        this.pendings = this.pendings.slice().sort((p1, p2) => this.comparing(p1, p2));
      }
    }
  }

  goTo(p: Pending) {
    this.router.navigateByUrl('/questionnaire-compile/' + p.type.toLowerCase() + '/' + p.uuid + '/' + p.doctorID +
      '/' + p.patientSSN + '/questionnaires');
  }

  comparing(r1, r2) {
    const first = r1.id.split(' ');
    const second = r2.id.split(' ');
    const d1 = moment(first[0], 'DD/MM/YYYY').toDate().getTime();
    const d2 = moment(second[0], 'DD/MM/YYYY').toDate().getTime();
    return d1 < d2 ? 1 : (d1 > d2 ? -1 : 0);
  }
}

